/**
 * A ordem e as dobras das seções do painel do caso, por PESSOA (29/10, pedido
 * da Laura via Eduardo).
 *
 * A regra da casa era "nunca colapsável": a coluna abria tudo plano, na ordem
 * do código. Quem atende o previdenciário olha a ficha antes dos documentos, e
 * o histórico nunca — a coluna é de quem a usa o dia inteiro, então a ordem e o
 * que fica dobrado passam a ser escolha dela, guardada por login.
 * ponytail: `localStorage` por login e aparelho; vai para o servidor se alguém
 * reclamar de arrumar de novo noutra máquina.
 */
import { useCallback, useEffect, useState } from "react";

export const SECOES_DO_PAINEL = ["documentos", "pendencias", "reunioes"];

/** A ordem guardada, sem chave morta, com a seção nova no fim. */
export function ordemDasSecoes(salva) {
  const validas = (Array.isArray(salva) ? salva : []).filter((k, i, a) => SECOES_DO_PAINEL.includes(k) && a.indexOf(k) === i);
  return [...validas, ...SECOES_DO_PAINEL.filter((k) => !validas.includes(k))];
}

/** `chave` vai para a posição `para` (índice na ordem sem ela). */
export function moverSecao(ordem, chave, para) {
  const sem = ordem.filter((k) => k !== chave);
  sem.splice(Math.max(0, Math.min(para, sem.length)), 0, chave);
  return sem;
}

const chaveDe = (usuario) => `painel:${usuario ?? ""}`;

function ler(usuario) {
  try {
    const v = JSON.parse(localStorage.getItem(chaveDe(usuario)) ?? "{}");
    return { ordem: ordemDasSecoes(v.ordem), fechadas: (v.fechadas ?? []).filter((k) => SECOES_DO_PAINEL.includes(k)) };
  } catch {
    return { ordem: [...SECOES_DO_PAINEL], fechadas: [] };
  }
}

export function usePreferenciaDoPainel(usuario) {
  const [pref, setPref] = useState(() => ler(usuario));
  /* Trocar de login no mesmo aparelho troca a arrumação junto. */
  useEffect(() => setPref(ler(usuario)), [usuario]);
  const gravar = useCallback(
    (muda) =>
      setPref((antes) => {
        const nova = muda(antes);
        try {
          localStorage.setItem(chaveDe(usuario), JSON.stringify(nova));
        } catch {
          /* aba privada: vale até recarregar */
        }
        return nova;
      }),
    [usuario],
  );
  return {
    ordem: pref.ordem,
    fechada: (chave) => pref.fechadas.includes(chave),
    alternar: (chave, aberta) =>
      gravar((p) => ({ ...p, fechadas: aberta ? p.fechadas.filter((k) => k !== chave) : [...new Set([...p.fechadas, chave])] })),
    mover: (chave, para) => gravar((p) => ({ ...p, ordem: moverSecao(p.ordem, chave, para) })),
  };
}
